import React from 'react';
import { useSettings } from '@wix/tpa-settings/react';
import settingsParams, { pluginsKeys } from '../settings-params';

const withSettings =
  <P extends object>(Comp: React.ComponentType<P>): React.FC<P> =>
  (props) => {
    const settings = useSettings();
    const selectedPlugins: any = {};

    pluginsKeys.forEach((pluginKey) => {
      selectedPlugins[pluginKey] = settings.get(settingsParams[pluginKey]);
    });

    const useNewPluginMenu = settings.get(settingsParams.useNewPluginMenu);
    const useFontSize = settings.get(settingsParams.useFontSize);
    const showImportExport = settings.get(settingsParams.showImportExport);
    const useLinkToSection = settings.get(settingsParams.useLinkToSection);
    const useVerticalSlimLayout = settings.get(
      settingsParams.useVerticalSlimLayout,
    );
    const clickToTweet = settings.get(settingsParams.clickToTweet);
    const useStickyToolbar = settings.get(settingsParams.useStickyToolbar);
    return (
      <Comp
        selectedPlugins={selectedPlugins}
        useNewPluginMenu={useNewPluginMenu}
        useStickyToolbar={useStickyToolbar}
        useFontSize={useFontSize}
        showImportExport={showImportExport}
        useLinkToSection={useLinkToSection}
        clickToTweet={clickToTweet}
        useVerticalSlimLayout={useVerticalSlimLayout}
        {...(props as P)}
      />
    );
  };

export { withSettings };
